import React from "react";
import PropTypes from "prop-types";
import "./BillCard.css";
import Card from "@mui/joy/Card";
import CardContent from "@mui/joy/CardContent";
import Typography from "@mui/joy/Typography";
import Chip from "@mui/joy/Chip";
import ArrowOutwardIcon from "@mui/icons-material/ArrowOutward";
import { format } from "date-fns";
import avatar from "../../Male_Avatar.jpg";
import { Stack } from "@mui/joy";

function formatDate(dateString) {
  return format(new Date(dateString), "MMM d, yyyy");
}

const BillCard = ({ bill }) => {
  const goToDetails = (event) => {
    event.preventDefault();

    const url = new URL(window.location.href.slice(0, window.location.href.length - 6) + '/details');
    url.searchParams.set("congress", bill.congress);
    url.searchParams.set("type", bill.type);
    url.searchParams.set("billIdNumber", bill.billIdNumber || bill.number);
    window.history.pushState({}, "", url.toString());

    // communicate to Routes that URL has changed
    const navEvent = new PopStateEvent('popstate');
    window.dispatchEvent(navEvent);
  };

  return (
    <Card
      alt={bill.sponsor.party + " sponsored bill"}
      variant="plain"
      sx={(theme) => ({
        minWidth: '250px',
        display: "flex",
        flexDirection: "column",
        flexGrow: 1,
        boxShadow: theme.shadow.md,
        cursor: 'pointer',
        borderTop: (theme) =>
          `16px solid ${
            bill.sponsor.party === "D" || bill.party === "Democratic"
              ? theme.vars.palette.primary[500]
              : bill.sponsor.party === "R" || bill.party === "Republican"
              ? theme.vars.palette.danger[500]
              : theme.vars.palette.warning[200]
          }`,
      })}
      component="a"
      onClick={(e) => goToDetails(e)}
    >
      <CardContent flexGrow={1} sx={{ justifyContent: "space-between" }}>
        <Stack>
          <Typography level="title-sm">{bill.category}</Typography>
          <Stack
            direction={"row"}
            spacing={2}
            alignItems="flex-start"
            sx={{ mt: 1, mb: 2 }}
          >
            <Typography level="h3" sx={{ flexGrow: 1 }}>
              {bill.title || bill.fullTitle}
            </Typography>
            <ArrowOutwardIcon color="secondary" fontSize="lg" />
          </Stack>
          <Stack direction="row" flexWrap="wrap" gap={1} sx={{ mb: 2 }}>
            {bill.tags?.map((tag, index) => (
              <Chip
                variant="soft"
                color="primary"
                size="sm"
                key={index}
                style={{ marginRight: "8px", marginBottom: "4px" }}
              >
                {tag}
              </Chip>
            ))}
          </Stack>
        </Stack>
        <Stack
          className="author"
          direction="row"
          spacing={2}
          alignItems="center"
        >
          <img
            src={bill.sponsor.imageUrl || bill.authorImage || avatar}
            alt={bill.sponsor.name}
          />
          <Stack direction={"column"}>
            <Typography level="title-sm">
              {bill.sponsor.name || bill.sponsor}
            </Typography>
            <Typography level="body-sm">
              {formatDate(bill.updateDate)}
            </Typography>
          </Stack>
        </Stack>
      </CardContent>
    </Card>
  );
};

// Prop types for our Component
BillCard.propTypes = {
  bill: PropTypes.object.isRequired,
};

// Default Props for our Component
BillCard.defaultProps = {};

export default BillCard;
